import { Routes, Route } from "react-router-dom";
import ListPlans from "../Components/plans/listplans";
import AddPlan from "../Components/plans/addPlan";
import ViewPlan from "../Components/plans/ViewPlan";
const PlanRoutes= () => {
  return (
    <Routes>
      <Route path="/Plans" element={<ListPlans/>}></Route>
       <Route path="/Plans/Add" element=  {<AddPlan/>}></Route>
      <Route path="/Plan/view/:id" element={<ViewPlan/>}></Route>
  
      {/* <Route path="/builders/:id/review" element={}></Route> */} 
    </Routes>
  );
};

export default PlanRoutes

